import React from 'react';
import PropTypes from 'prop-types';
import defaultStyles from './LoadingText.module.scss';

const LoadingText = ({ text, styles }) => (
    <div className={ styles.loading }>{text}</div>
);

LoadingText.propTypes = {
    styles: PropTypes.objectOf(PropTypes.string),
    text: PropTypes.string
};

LoadingText.defaultProps = {
    styles: defaultStyles,
    text: ''
};

export default LoadingText;
